<template>
    <div :class="menu ? 'menu-active' : ''">
        <header id="header" class="oswald">
            <div id="preheader" class="sitecolor-content">
                <div class="container">
                    <div class="row align-items-center justify-content-between">
                        <div class="col-6 d-md-none">
                            <router-link
                                :to="{ name: 'front.home' }"
                                class="logo d-lg-none router-link-active"
                                :style='"background-image: url(" + footer.logo + ")"'>
                                <div class="h4 m-0">
                                    <template v-if="footer.tipo == 1">
                                        {{ configuracion.title }}
                                    </template>                                    
                                </div>
                            </router-link>
                        </div>

                        <div class="col-md-4 d-none d-md-flex" style="text-transform: uppercase">
                            {{ $t('header.venta_entradas', { entradas: footer.termino_entradas }) }}
                        </div>

                        <div class="col-6 col-md-4 text-right">
                            <a href="https://www.compralaentrada.com" target="_blank" class="d-none d-lg-block"><img src="https://apiteatros.compralaentrada.com/images/logo_compralaentrada_white.png" width="180"></a>

                            <div class="hamburger d-lg-none hamburger--spring js-hamburger">
                                <div class="hamburger-box" @click="showMenu()">
                                    <div class="hamburger-inner"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!-- navbar -->
            <div class="container-navbar">
                <div class="row align-items-center">
                    <div class="style-navbar-escudo">
                        <router-link
                            :to="{ name: 'front.home' }"
                            class="logo router-link-active"
                            :style='"background-image: url(" + footer.logo + ")"'
                            @click="menu = false"
                        >
                            <div class="h3 m-0" v-if="footer.tipo == 1">{{ configuracion.title }}</div>
                        </router-link>
                    </div>

                    <div class="style-navbar">
                        <OptionsMenuComponent 
                            :footer="footer" 
                            :configuracion="configuracion" ul_class="d-flex m-0 justify-content-end"
                            @closeMenu="menu = false"
                        ></OptionsMenuComponent>
                    </div>
                </div>
            </div>
        </header>
        <div id="aside">
            <div class="container">
                <div class="row align-items-end">
                    <div class="col-12">
                        <OptionsMenuComponent 
                            btn_class="home-link d-flex text-center justify-content-center align-center align-items-center" 
                            :footer="footer"
                            :configuracion="configuracion"
                            @closeMenu="menu = false"
                        ></OptionsMenuComponent>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OptionsMenuComponent from './OptionsMenuComponent.vue';

export default {
    data() {
        return {
            menu: false
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        url() {
            return this.$route.name;
        },
        footer() {
            return this.$store.getters.getFooter;
        }
    },
    watch: {
        url() {
            this.menu = false;
        }
    },
    methods: {
        showMenu() {
            this.menu = !this.menu;
        }
    },
    components: {
        OptionsMenuComponent
    }
}
</script>

<style scoped>
    .h3 {
        align-items: left;
    }

    .sitecolor-content {
        height: 2em;
        display: flex;
        justify-content: center;
        text-align: center;
    }
    
    .container-navbar {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .style-navbar {
        display: grid;
        text-align: center;
        place-items: center  ;
    }

    .style-navbar-escudo {
        justify-content: center;
    }
    @media (max-width: 768px) {
        .style-navbar {
            display: none;
        }
        .style-navbar-escudo {
            display: none;
        }
    }
</style>